/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPauseShapeIcon64Regular = forwardRef('MediaUiAPauseShapeIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 8a4 4 0 0 0-4 4v40a4 4 0 0 0 4 4h7a4 4 0 0 0 4-4V12a4 4 0 0 0-4-4h-7Zm-1 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v40a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1V12Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M40 8a4 4 0 0 0-4 4v40a4 4 0 0 0 4 4h7a4 4 0 0 0 4-4V12a4 4 0 0 0-4-4h-7Zm-1 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v40a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1V12Z" })));
});
